import { Youtube, Instagram, Facebook } from "lucide-react";

/**
 * Crawlable social link row — real <a> tags with proper rel/aria attributes
 * for SEO entity association (works alongside the JSON-LD `sameAs` block
 * in /index.html). Used in both Navbar and Footer.
 *
 * Order is fixed brand priority: TikTok → YouTube → Instagram.
 */
export const SOCIAL_LINKS = [
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@episodekit",
    label: "Follow EpisodeKit on TikTok",
    // Lucide doesn't ship a TikTok glyph — inline a clean monochrome one
    // so it sits visually alongside the other lucide icons.
    Icon: ({ className }) => (
      <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        className={className}
        aria-hidden="true"
      >
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.05a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.48z" />
      </svg>
    ),
  },
  {
    name: "YouTube",
    href: "https://www.youtube.com/@EpisodeKit",
    label: "Subscribe to EpisodeKit on YouTube",
    Icon: ({ className }) => <Youtube className={className} aria-hidden="true" />,
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/episodekit/",
    label: "Follow EpisodeKit on Instagram",
    Icon: ({ className }) => (
      <Instagram className={className} aria-hidden="true" />
    ),
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/share/1BgW6EPvBJ/",
    label: "Follow EpisodeKit on Facebook",
    Icon: ({ className }) => (
      <Facebook className={className} aria-hidden="true" />
    ),
  },
];

const SocialLinks = ({ size = "sm", className = "" }) => {
  const iconCls =
    size === "lg" ? "w-5 h-5" : size === "md" ? "w-[18px] h-[18px]" : "w-4 h-4";
  const wrap =
    size === "lg"
      ? "w-10 h-10"
      : size === "md"
        ? "w-9 h-9"
        : "w-8 h-8";

  return (
    <ul
      className={`flex items-center gap-2 ${className}`}
      data-testid="social-links"
    >
      {SOCIAL_LINKS.map(({ name, href, label, Icon }) => (
        <li key={name}>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            title={label}
            data-testid={`social-${name.toLowerCase()}`}
            className={`${wrap} inline-flex items-center justify-center rounded-full text-neutral-400 hover:text-white hover:bg-white/5 transition-colors border border-transparent hover:border-purple-500/30`}
          >
            <Icon className={iconCls} />
          </a>
        </li>
      ))}
    </ul>
  );
};

export default SocialLinks;
